import { useState } from 'react';

const faqs = [
  {
    q: 'Who provides professional carpet cleaning near me in Snellville and Metro Atlanta?',
    a: 'Carpet & Flooring Transformers provides professional carpet cleaning throughout Snellville, Lawrenceville, Duluth, Grayson, Loganville, and the entire Metro Atlanta area. Our certified technicians use truck-mounted hot water extraction systems to deliver deep, lasting results. Call 770.236.1255 to schedule.',
  },
  {
    q: 'How much does professional carpet cleaning cost in Atlanta?',
    a: 'Carpet cleaning pricing depends on square footage, number of rooms, and carpet condition. We offer transparent, upfront pricing with no hidden fees. Most residential jobs range from $100 to $300. Call 770.236.1255 for a free, no-obligation estimate tailored to your home.',
  },
  {
    q: 'How long does carpet cleaning take?',
    a: 'Most carpet cleaning appointments take one to three hours depending on the area size and soiling level. Carpets are typically dry and ready for light foot traffic within four to six hours. We work efficiently to minimize disruption to your day.',
  },
  {
    q: 'What flooring installation services do you offer in Snellville, GA?',
    a: 'We install luxury vinyl plank, hardwood, engineered wood, laminate, carpet, and tile throughout Metro Atlanta. Our professional installers handle everything from measurement and material selection to final inspection. We carry top brands including Mohawk, Shaw, MSI, and Dreamweaver.',
  },
  {
    q: 'Do you offer same-day carpet cleaning or flooring service?',
    a: 'Same-day service is available based on technician availability. We recommend calling early at 770.236.1255 to check availability. We do our best to accommodate urgent requests, especially for water damage or emergency carpet cleaning situations.',
  },
  {
    q: 'Are your cleaning products safe for pets and children?',
    a: 'Yes. We use eco-friendly, non-toxic cleaning solutions that are safe for children, pets, and the environment. Our products are effective at removing deep-set stains and odors without leaving harmful residues. Your family\'s safety is always our priority.',
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="py-28 bg-white">
      <div className="max-w-3xl mx-auto px-6">

        <div className="text-center mb-14">
          <p className="text-amber-600 text-[11px] font-bold tracking-[0.25em] uppercase mb-3">Common Questions</p>
          <h2 className="font-serif text-4xl md:text-5xl text-stone-900 mb-4">Frequently Asked Questions</h2>
          <div className="w-16 h-px bg-amber-500 mx-auto mb-5"></div>
          <p className="text-stone-500 text-base">Everything you need to know before booking your service.</p>
        </div>

        <div
          className="space-y-2"
          itemScope
          itemType="https://schema.org/FAQPage"
        >
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`border rounded-xl overflow-hidden transition-colors ${open === i ? 'border-amber-200 bg-amber-50/40' : 'border-stone-100 bg-white'}`}
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
            >
              <button
                className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer"
                onClick={() => setOpen(open === i ? null : i)}
                aria-expanded={open === i}
              >
                <span className="font-semibold text-stone-800 text-sm md:text-[15px] leading-snug" itemProp="name">
                  {faq.q}
                </span>
                <div className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 ${open === i ? 'bg-amber-600 text-white rotate-45' : 'bg-stone-100 text-stone-500'}`}>
                  <i className="ri-add-line text-base"></i>
                </div>
              </button>
              {open === i && (
                <div
                  className="px-6 pb-6"
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <p className="text-stone-500 text-sm leading-relaxed" itemProp="text">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-stone-400 text-sm mb-4">Still have questions? We&apos;re happy to help.</p>
          <a
            href="tel:7702361255"
            className="inline-flex items-center gap-2 border border-stone-300 hover:border-stone-900 text-stone-700 hover:text-stone-900 font-semibold text-sm px-7 py-3.5 rounded-full transition-colors whitespace-nowrap cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-line"></i>
            </div>
            Call 770.236.1255
          </a>
        </div>
      </div>
    </section>
  );
}
